<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default{
  mounted() {
    window.addEventListener(
      "hashchange",
      () => {
        let currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);
        }
      },
      false
    );
  },
};
</script>

<style lang="less">
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
body .el-table::before {
    z-index: inherit;
}
#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>



// WEBPACK FOOTER //
// src/App.vue